import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const GuestsTabSkeleton = () => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <Skeleton className="h-10 w-[130px]" />
      <Skeleton className="h-10 w-[170px]" />
    </div>

    <Skeleton className="h-10 max-w-md" />

    <Card className="p-4">
      <div className="grid grid-cols-12 gap-4 px-2 pb-4">
        {[...Array(12)].map((_, i) => (
          <Skeleton key={`header-${i}`} className="h-5 w-full" />
        ))}
      </div>

      <div className="space-y-4">
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    </Card>
  </div>
);

export default GuestsTabSkeleton;
